import httpClient from '../../httpClient';
import { PaginatedData, PaginationParams } from 'models/PaginatedData';
import { DataRoomRfiTemplate } from 'router/subrouters/DataRoom/models/DataRoomRfi';

function create(dataRoomId: string, values: Partial<DataRoomRfiTemplate>) {
  return httpClient.post(
    `data-room-rfi-templates/data-rooms/${dataRoomId}`,
    values,
  );
}

function get(dataRoomId: string, params?: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomRfiTemplate>>(
    `data-room-rfi-templates/data-rooms/${dataRoomId}`,
    {
      params,
    },
  );
}

function update(
  dataRoomId: string,
  rfiTemplateId: string,
  values: Partial<DataRoomRfiTemplate>,
) {
  return httpClient.patch(
    `data-room-rfi-templates/${rfiTemplateId}/data-rooms/${dataRoomId}`,
    values,
  );
}

function remove(dataRoomId: string, rfiTemplateId: string) {
  return httpClient.post(
    `data-room-rfi-templates/${rfiTemplateId}/data-rooms/${dataRoomId}/delete-request`,
  );
}

function undoRemove(dataRoomId: string, rfiTemplateId: string) {
  return httpClient.post(
    `data-room-rfi-templates/${rfiTemplateId}/data-rooms/${dataRoomId}/undo-delete-request`,
  );
}

export default {
  create,
  get,
  update,
  remove,
  undoRemove,
};
